import * as React from 'react';

const SvgInformationCircleSolid = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M2.719 12.76c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.366 9.75-9.75 9.75-9.75-4.366-9.75-9.75m9.75-4.75a1 1 0 0 0-1 1v.007a1 1 0 0 0 1 1h.007a1 1 0 0 0 1-1v-.008a1 1 0 0 0-1-1zm-1.645 4.447a1 1 0 0 0 .927.552l-.607 2.426c-.363 1.45 1.143 2.658 2.48 1.99l.042-.021a1 1 0 0 0-.479-1.895l.606-2.425c.363-1.45-1.143-2.658-2.48-1.99l-.042.02a1 1 0 0 0-.447 1.342"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgInformationCircleSolid;
